<div class="flex flex-col px-8 py-4">
  <app-section-header [title]="'My Settings'"></app-section-header>

  <ng-container *ngIf="{ value: userSettings$ | async } as response">
    <app-processing-boundary
      [isProcessing]="isProcessing || !prevUserSettings"
      [processingMsg]="'Loading...'"
    >
      <form
        *ngIf="prevUserSettings"
        [formGroup]="form"
        class="flex flex-col font-sans gap-y-4"
        (keydown.enter)="$event.preventDefault()"
      >
        <mat-accordion [multi]="true">
          <app-expandable-section-box
            [title]="'Email address'"
            [iconClass]="'icon-envelope'"
            [isExpandable]="false"
          >
            <div
              class="flex flex-col flex-1 px-2 py-0"
              data-testid="formFieldBodyEmail"
              id="formFieldBodyEmail"
              expandedContent
            >
              <mat-form-field appearance="outline">
                <input
                  class="pb-[0.1rem]"
                  type="email"
                  matInput
                  [formControl]="form.get(FORM_PATHS.EMAIL())"
                  placeholder="emailaddress@citywire.co.uk"
                  data-testid="emailInput"
                />
              </mat-form-field>
              <mat-error
                *ngIf="form.get(FORM_PATHS.EMAIL()).hasError('email')"
                class="pb-1 text-sm"
              >
                Please enter a valid email address
              </mat-error>
            </div>
          </app-expandable-section-box>

          <app-expandable-section-box
            [title]="'Authors'"
            [iconClass]="'icon-user'"
            [isExpandable]="false"
          >
            <div
              class="flex flex-col gap-y-[0.3rem] py-0 px-2 flex-1"
              data-testid="formFieldBodyAuthors"
              id="formFieldBodyAuthors"
              expandedContent
            >
              <app-auto-complete
                class="flex flex-col flex-1"
                [searchList]="searchList"
                [searchBarControl]="form.get(FORM_PATHS.SEARCHED_AUTHOR())"
                [isSearching]="isSearchingAuthors"
                (handleSelectedResult)="handleAuthorSelected($event)"
                (handleSearchValue)="onSearch($event)"
              ></app-auto-complete>

              <div
                class="flex flex-col px-0 py-2 m-0 border-t border-t-project-100"
                *ngIf="form.get(FORM_PATHS.SELECTED_AUTHORS())?.value.length"
              >
                <ng-container
                  *ngFor="
                    let selectedAuthor of form.get(
                      FORM_PATHS.SELECTED_AUTHORS()
                    ).value;
                    odd as isOdd;
                    even as isEven
                  "
                >
                  <div
                    class="flex justify-between px-4 py-2"
                    data-testid="selectedAuthor"
                    [ngClass]="{
                      'bg-project-2500': isEven,
                      'bg-project-2600': isOdd
                    }"
                  >
                    <div class="flex items-center flex-1 space-x-1">
                      <span>{{ selectedAuthor?.name }}</span>
                      <div class="flex items-center justify-center space-x-1">
                        <span>-</span>
                        <span *ngIf="selectedAuthor?.location">
                          {{ selectedAuthor?.location }}</span
                        >
                        <a routerLink="/admin/authors/{{ selectedAuthor.id }}"
                          >(<span
                            class="italic underline hover:text-project-2100"
                            >edit</span
                          >)</a
                        >
                      </div>
                    </div>
                    <button
                      class="text-base border-none bg-none text-project-100 hover:cursor-pointer hover:text-project-2700"
                      data-testid="selectedAuthorDeleteBtn"
                      title="Remove author"
                      (click)="onRemoveAuthor(selectedAuthor)"
                    >
                      <i class="icon icon-minus-circle"></i>
                    </button>
                  </div>
                </ng-container>
              </div>
            </div>
          </app-expandable-section-box>

          <app-expandable-checkbox-list
            [iconClass]="'icon-globe'"
            [title]="'Editions'"
            [formGroup]="form.get(FORM_PATHS.WEBSITES())"
            [metadata]="deliveryTargets$ | async"
            [isExpandable]="false"
          ></app-expandable-checkbox-list>

          <app-expandable-dropdown
            id="formFieldBodyLanguage"
            [iconClass]="'icon-language'"
            [title]="language"
            [sectionFormControl]="form.get(FORM_PATHS.LANGUAGE())"
            [labelKey]="'FriendlyName'"
            [options]="languages$ | async"
            [defaultOption]="DEFAULT_LANGUAGE_OPTION"
            [isExpandable]="false"
          ></app-expandable-dropdown>
        </mat-accordion>
        <div>
          <button
            mat-button
            color="primary"
            type="submit"
            (click)="onSaveSettings()"
            [disabled]="form.invalid || !form.dirty || isSaving"
            mat-raised-button
            data-testid="formSubmitBtn"
          >
            <span *ngIf="!isSaving; else saving"> Save </span>
            <ng-template #saving>
              <span>Saving...</span>
            </ng-template>
          </button>
        </div>
      </form>
    </app-processing-boundary>
  </ng-container>
</div>
